export default __webpack_public_path__ + "static/media/how-work-img-03.e1c59b3c.svg";